import { render, staticRenderFns } from "./blade-canvas.vue?vue&type=template&id=44c703bc&scoped=true&"
import script from "./blade-canvas.vue?vue&type=script&lang=js&"
export * from "./blade-canvas.vue?vue&type=script&lang=js&"
import style0 from "./blade-canvas.vue?vue&type=style&index=0&id=44c703bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c703bc",
  null
  
)

export default component.exports